import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../components/Button";
import Input from "../../../components/Form/Input/input";
import { FormGroup, Form } from "../../../components/Form/styles";
import { Box } from "../../../components/Layout";
import { RegisterData, RegisterPageProps } from "../types";

// Name and password (the e-mail is shown above the form, to change on step 1): "Mostrar senha" instead of typing
// the password twice
const RegisterStep2Page = ({
  data,
  setData,
  onNextStep,
  loading,
}: RegisterPageProps & {
  setData: (data: RegisterData) => void;
  onNextStep: () => void;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const blocked = !data.email || !data.name.trim() || !data.password || loading;

  return (
    <Box className="!mx-0 !mt-0" borderBottom>
      <Form
        className="flex flex-col"
        onSubmit={e => {
          e.preventDefault();
          if (!blocked) {
            onNextStep();
          }
        }}>
        <FormGroup>
          <Input
            onChange={e => setData({ ...data, name: e.target.value })}
            label={t("pages.register.form.nameLabel")}
            value={data.name}
            id="name"
            type="text"
            autoFocus // right after the e-mail step: type the name straight away
            placeholder={t("pages.register.form.namePlaceholder")}
          />
        </FormGroup>
        <FormGroup>
          <Input
            onChange={e => setData({ ...data, password: e.target.value })}
            label={t("pages.register.form.passwordLabel")}
            value={data.password}
            id="password"
            type={showPassword ? "text" : "password"}
            placeholder={t("pages.register.form.passwordPlaceholder")}
          />
        </FormGroup>
        <button
          type="button"
          onClick={() => setShowPassword(shown => !shown)}
          aria-pressed={showPassword}
          className="-mt-3 mb-5 self-start text-xs font-semibold underline underline-offset-2">
          {showPassword ? t("pages.register.form.hidePassword") : t("pages.register.form.showPassword")}
        </button>
        <Button onClick={() => onNextStep()} type="INFO" size="LG" block disabled={blocked} $loading={loading}>
          {t("pages.register.form.confirmRegister")}
        </Button>
        {/* The visible Button is a styled div; this lets Enter submit the form */}
        <button type="submit" className="sr-only" tabIndex={-1} aria-hidden="true" />
      </Form>
    </Box>
  );
};

export default RegisterStep2Page;
